import React, { Component, useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector, useDispatch, useStore } from 'react-redux';
// import store from '../app/store';
import { setCurrentMenu } from '../features/menu/menuSlice';
import useVisibleOnScreen from "./visible";
import {getChannel} from "postal";

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import DatasetIcon from '@mui/icons-material/Dataset';
import RuleIcon from '@mui/icons-material/Rule';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SettingsIcon from '@mui/icons-material/Settings';
import SecurityIcon from '@mui/icons-material/Security';
import ContactsIcon from '@mui/icons-material/Contacts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import GroupsIcon from '@mui/icons-material/Groups';

import SchemaIcon from '@mui/icons-material/Schema';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import StorageIcon from '@mui/icons-material/Storage';
import TableChartIcon from '@mui/icons-material/TableChart';


import { MessageHooks } from "../App";

import { EditTemplate } from "./workflow/management-workflow-template";
import { EditWorkflow } from "./workflow/management-workflow-attributes";
import { PublishedWorkflows } from "./workflow/management-workflow-published";
import { RuntimeWorkflows } from "./workflow/management-workflow-runtime";
import { WorkflowForms } from "./workflow/management-workflow-forms";
import { WorkflowFormLists } from "./workflow/management-workflow-forms";
import { DocumentConfiguration } from "./document/management-config";
import { EffectivityEditor } from "./document/management-effectivity";
import { WorkflowDefinitions } from "./workflow/management-workflow-definitions";
import { MobileUsers } from "./acl/management-mobile-users";
import { AclConfiguration } from "./acl/management-acl";
import { RolesConfiguration } from "./acl/management-roles";
import { UserInfo, netGet, netPost } from "./network";

const postal = getChannel('ucs');

const ACL_PATH = [
    '/C/management/workflow',
    '/C/management/workflow/templates',
    '/C/management/workflow/profiles',
    '/C/management/workflow/forms',
    '/C/management/workflow/published',
    '/C/management/workflow/runtime',
    '/C/management/document',
    '/C/management/document/config',
    '/C/management/security', 
    '/C/management/security/acl',
    '/C/management/workflow/definitions',
    '/C/management/security/musers',
    '/C/management/database',
    '/C/management/database/eff',
    '/C/management/security/roles',
];

const WORKFLOW_INDEX = 0;
const TEMPLATES_INDEX = 1;
const PROFILES_INDEX = 2;
const FORMS_INDEX = 3;
const PUBLISHED_INDEX = 4;
const RUNTIME_INDEX = 5;
const DOCUMENT_INDEX = 6;
const DOC_CONFIG_INDEX = 7;
const SECURITY_INDEX = 8;
const ACL_INDEX = 9;
const DEFINITIONS_INDEX = 10;
const MOBILE_USERS_INDEX = 11;
const DATABASE_INDEX = 12;
const DATABASE_EFF_INDEX = 13;
const ROLES_INDEX = 14;


function ManagementMenu(props) {
    const [menuIcon, setMenuIcon] = React.useState('app');
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [pendingUpdates, setPendingUpdates] = useState(false);
    const theme = useTheme();
    const [isVisible, containerRef] = useVisibleOnScreen();
    const [aclOpen, setAclOpen] = useState(false);
    const [menuACL, setMenuACL] = useState([]);

    // const currentMenu = useSelector((state) => state.menu.currentMenu);
    // const store = useStore();

    React.useEffect(() => {
        // console.log('MNGNT VISIBLE: ' + isVisible);
        if ( isVisible ) {
            // store.dispatch(setCurrentMenu('management'));
            postal.publish(
                "app.menu.change",
                {
                    menu: 'management',
                }
            );
            // console.log('Posting currentMenu = management');
            if ( pendingUpdates ) {
                setPendingUpdates(false);
                // loadUpdates();
            }
            readACLs();
        }
    }, [isVisible]);

    const readACLs = () => {
        const aclm = [];
        const aparams = [];
        ACL_PATH.forEach( aclPath => {
            aparams.push({
                path: aclPath,
                action: 'BROWSE',
                subjects: UserInfo.info.roles,
            });
            aparams.push({
                path: aclPath,
                action: 'READ',
                subjects: UserInfo.info.roles,
            });
            
            aparams.push({
                path: aclPath,
                action: 'WRITE',
                subjects: UserInfo.info.roles,
            });
            
        });
        netPost('/api/auth/acl/eval/multi', {
            params: aparams
        }).then(response => {
            if (!response.ok) {
                throw new Error('Status: ' + response.status);
            }
            return response.json();
        })
            .then(data => {
                // console.log('ACL Result [MANAGEMENT] = ' + JSON.stringify(data));
                if (Array.isArray(data)) {
                    for (let i = 0; i < data.length; i += 3) {
                        aclm.push({
                            hide: !data[i].result,
                            disabled: !data[i + 1].result,
                            write: data[i + 2].result,
                        });
                    }

                    setMenuACL(aclm);
                    // console.log('MNGNT MENU ACL: ' + JSON.stringify(aclm));
                }

            }).catch(error => {
                console.log('Error: ' + error);
            });
    }

    /*
    useEffect( () => {
        console.log('MNGNT currentMenu changed = ' + currentMenu);
    },[currentMenu]);
    */

    const handleTemplateAction = (event) => {
        // ManagementModule.pageChange(<EditTemplate/>)
        ManagementModule.setCard({name: 'EditTemplate', page: <EditTemplate/>, reuse: false, right: false});
        setSelectedIndex(TEMPLATES_INDEX);
        setAclOpen(false);
    };

    const handleWorkflowAction = (event) => {
        // ManagementModule.pageChange(<EditWorkflow/>);
        ManagementModule.setCard({name: 'EditWorkflow', page: <EditWorkflow readOnly={!menuACL[PROFILES_INDEX].write}/>, reuse: false, right: false});
        setSelectedIndex(PROFILES_INDEX);
        setAclOpen(false);
    };

    const handleFormsAction = (event) => {
        // ManagementModule.pageChange(<WorkflowForms/>);
        ManagementModule.setCard({name: 'WorkflowForms', page: <WorkflowForms readOnly={!menuACL[FORMS_INDEX].write}/>, reuse: false, right: false});
        setSelectedIndex(FORMS_INDEX);
        setAclOpen(false);
    }

    const handleListsAction = (event) => {
        // ManagementModule.pageChange(<WorkflowFormLists/>);
        ManagementModule.setCard({name: 'WorkflowFormLists', page: <WorkflowFormLists/>, reuse: false, right: false});
        setSelectedIndex(5);
        setAclOpen(false);
    }

    const handlePublishedAction = (event) => {
        // ManagementModule.pageChange(<PublishedWorkflows/>);
        ManagementModule.setCard({name: 'PublishedWorkflows', page: <PublishedWorkflows readOnly={!menuACL[PUBLISHED_INDEX].write}/>, reuse: false, right: false});
        setSelectedIndex(PUBLISHED_INDEX);
        setAclOpen(false);
    };

    const handleRuntimeAction = (event) => {
        // ManagementModule.pageChange(<RuntimeWorkflows readOnly={!menuACL[RUNTIME_INDEX].write} />);
        ManagementModule.setCard({name: 'RuntimeWorkflows', page: <RuntimeWorkflows readOnly={!menuACL[RUNTIME_INDEX].write}/>, reuse: false, right: false});
        setSelectedIndex(RUNTIME_INDEX);
        setAclOpen(false);
        // console.log('Runtime ACL: ' + JSON.stringify(menuACL[RUNTIME_INDEX]));
    };

    const handleDefinitionsAction = (event) => {
        // ManagementModule.pageChange(<WorkflowDefinitions readOnly={!menuACL[DEFINITIONS_INDEX].write} />);
        ManagementModule.setCard({name: 'WorkflowDefinitions', page: <WorkflowDefinitions readOnly={!menuACL[DEFINITIONS_INDEX].write} />, reuse: false, right: false});
        setSelectedIndex(DEFINITIONS_INDEX);
        setAclOpen(false);
    };

    const handleRolesAction = (event) => {
        // ManagementModule.pageChange(<RolesConfiguration readOnly={!menuACL[ROLES_INDEX].write} open={true}/>);
        ManagementModule.setCard({name: 'RolesConfiguration', page: <RolesConfiguration readOnly={!menuACL[ROLES_INDEX].write} open={true}/>, reuse: false, right: false});
        setSelectedIndex(ROLES_INDEX);
        setAclOpen(false);
    };

    const handleMenuIconClick = (event) => {
        if ( menuIcon === 'back' ) {
            ManagementModule.menuIconChange('app');
            setMenuIcon('app');
        } else {
            ManagementModule.menuIconChange('back');
            setMenuIcon('back');
        }
    };

    const handleDocsConfigAction = (event) => {
        // ManagementModule.pageChange(<DocumentConfiguration/>);
        ManagementModule.setCard({name: 'DocumentConfiguration', page: <DocumentConfiguration/>, reuse: false, right: false});
        setSelectedIndex(DOC_CONFIG_INDEX);
        setAclOpen(false);
    };

    const handleEffEditorAction = (event) => {
        // ManagementModule.pageChange(<EffectivityEditor/>);
        ManagementModule.setCard({name: 'EffectivityEditor', page: <EffectivityEditor/>, reuse: false, right: false});
        setSelectedIndex(DATABASE_EFF_INDEX);
        setAclOpen(false);
    };

    const handleAccessAction = (event) => {
        if ( selectedIndex !== ACL_INDEX) {
            setAclOpen(true);
            // ManagementModule.pageChange(<AclConfiguration open={true} />);
            ManagementModule.setCard({name: 'AclConfiguration', page: <AclConfiguration open={true} readOnly={!menuACL[ACL_INDEX].write} />, reuse: false, right: false});
        }
        setSelectedIndex(ACL_INDEX);
    };

    const handleMobileUsersAction = (event) => {
        // ManagementModule.pageChange(<MobileUsers readOnly={!menuACL[MOBILE_USERS_INDEX].write} />);
        ManagementModule.setCard({name: 'MobileUsers', page: <MobileUsers readOnly={!menuACL[MOBILE_USERS_INDEX].write} />, reuse: false, right: false});
        setSelectedIndex(MOBILE_USERS_INDEX);
        setAclOpen(false);
    };

    ManagementModule.onMenuIconClick = handleMenuIconClick;

    return (
        <Box ref={containerRef}
            sx={{ width: '100%', fontSize: '1.3em', padding: 0, paddingTop: "1ex", position: "relative" }}
            role="presentation"
        >
            <List  sx={{paddingBottom: 0}} >
                <ListItem key="mw-workflow" disablePadding sx={{display: Array.isArray(menuACL) && WORKFLOW_INDEX < menuACL.length && menuACL[WORKFLOW_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton>
                        <ListItemIcon sx={{ fontSize: 18, paddingRight: 0, minWidth: '40px' }}>
                            <SchemaIcon />
                        </ListItemIcon>
                        <ListItemText primary="Workflow" slotProps={{
                            primary: {
                                fontSize: 18,
                                fontWeight: theme.typography.fontWeightBold,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                {/*
                <ListItem key="mw-templates" disablePadding 
                    sx={{display: Array.isArray(menuACL) && TEMPLATES_INDEX < menuACL.length && menuACL[TEMPLATES_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleTemplateAction} selected={selectedIndex === TEMPLATES_INDEX} 
                        disabled={Array.isArray(menuACL) && TEMPLATES_INDEX < menuACL.length && menuACL[TEMPLATES_INDEX].disabled}>
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <FormatListNumberedIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Templates (deprecated)" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                 */}
                <ListItem key="mw-archetypes" disablePadding 
                    sx={{display: Array.isArray(menuACL) && PROFILES_INDEX < menuACL.length && menuACL[PROFILES_INDEX].hide ? "none" : "block"}}>
                    <ListItemButton onClick={handleWorkflowAction} selected={selectedIndex === PROFILES_INDEX}
                        disabled={Array.isArray(menuACL) && PROFILES_INDEX < menuACL.length && menuACL[PROFILES_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px' }}>
                            <RuleIcon  fontSize="inherit" />
                        </ListItemIcon>
                        <ListItemText primary="Templates & Profiling" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
                <ListItem key="mw-forms" disablePadding 
                    sx={{display: Array.isArray(menuACL) && FORMS_INDEX < menuACL.length && menuACL[FORMS_INDEX].hide ? "none" : "block"}}>
                    <ListItemButton onClick={handleFormsAction} selected={selectedIndex === FORMS_INDEX}
                        disabled={Array.isArray(menuACL) && FORMS_INDEX < menuACL.length && menuACL[FORMS_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px' }}>
                            <DatasetIcon  fontSize="inherit" />
                        </ListItemIcon>
                        <ListItemText primary="Forms" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>

                {/* 
                <ListItem key="mw-defs" disablePadding 
                    sx={{display: Array.isArray(menuACL) && DEFINITIONS_INDEX < menuACL.length && menuACL[DEFINITIONS_INDEX].hide ? "none" : "block"}}>
                    <ListItemButton onClick={handleDefinitionsAction} selected={selectedIndex === DEFINITIONS_INDEX}
                        disabled={Array.isArray(menuACL) && DEFINITIONS_INDEX < menuACL.length && menuACL[DEFINITIONS_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px' }}>
                            <FeaturedPlayListIcon  fontSize="inherit" />
                        </ListItemIcon>
                        <ListItemText primary="Definitions" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                */}

                {/*
                <ListItem key="mw-lists" disablePadding >
                    <ListItemButton onClick={handleListsAction} selected={selectedIndex === 5}>
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px' }}>
                            <ListIcon  fontSize="inherit" />
                        </ListItemIcon>
                        <ListItemText primary="Selection Lists" primaryTypographyProps={{
                            fontSize: 16,
                            fontWeight: theme.typography.fontWeightMedium,
                            letterSpacing: 0,
                        }} />
                    </ListItemButton>
                </ListItem>
                    */}
                <ListItem key="mw-published" disablePadding
                    sx={{display: Array.isArray(menuACL) && PUBLISHED_INDEX < menuACL.length && menuACL[PUBLISHED_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handlePublishedAction} selected={selectedIndex === PUBLISHED_INDEX}
                        disabled={Array.isArray(menuACL) && PUBLISHED_INDEX < menuACL.length && menuACL[PUBLISHED_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px'}}>
                            <PublishedWithChangesIcon  fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Published" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                <ListItem key="mw-runtime" disablePadding
                    sx={{display: Array.isArray(menuACL) && RUNTIME_INDEX < menuACL.length && menuACL[RUNTIME_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleRuntimeAction} selected={selectedIndex === RUNTIME_INDEX}
                        disabled={Array.isArray(menuACL) && RUNTIME_INDEX < menuACL.length && menuACL[RUNTIME_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0, paddingLeft: '40px', minWidth: '70px'}}>
                            <DirectionsRunIcon  fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Runtime" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
            </List>
            <List  sx={{paddingBottom: 0}} >
                <ListItem key="mw-docs" disablePadding 
                    sx={{display: Array.isArray(menuACL) && DOCUMENT_INDEX < menuACL.length && menuACL[DOCUMENT_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton>
                        <ListItemIcon sx={{ fontSize: 18, paddingRight: 0, minWidth: '40px' }}>
                            <MenuBookIcon />
                        </ListItemIcon>
                        <ListItemText primary="Documents" slotsProps={{
                            primary: {
                                fontSize: 18,
                                fontWeight: theme.typography.fontWeightBold,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                <ListItem key="mw-docs-config" disablePadding 
                    sx={{display: Array.isArray(menuACL) && DOC_CONFIG_INDEX < menuACL.length && menuACL[DOC_CONFIG_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleDocsConfigAction} selected={selectedIndex === DOC_CONFIG_INDEX}
                        disabled={Array.isArray(menuACL) && DOC_CONFIG_INDEX < menuACL.length && menuACL[DOC_CONFIG_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <SettingsIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Configuration" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            {/* Disable TEST */}
            <List  sx={{paddingBottom: 0}} >
                <ListItem key="mw-dbs" disablePadding 
                    sx={{display: Array.isArray(menuACL) && DATABASE_INDEX < menuACL.length && menuACL[DATABASE_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton>
                        <ListItemIcon sx={{ fontSize: 18, paddingRight: 0, minWidth: '40px' }}>
                            <StorageIcon />
                        </ListItemIcon>
                        <ListItemText primary="Databases" slotsProps={{
                            primary: {
                                fontSize: 18,
                                fontWeight: theme.typography.fontWeightBold,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                <ListItem key="mw-dbs-eff" disablePadding 
                    sx={{display: Array.isArray(menuACL) && DATABASE_EFF_INDEX < menuACL.length && menuACL[DATABASE_EFF_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleEffEditorAction} selected={selectedIndex === DATABASE_EFF_INDEX}
                        disabled={Array.isArray(menuACL) && DATABASE_EFF_INDEX < menuACL.length && menuACL[DATABASE_EFF_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <TableChartIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Effectivity" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            
            <List  sx={{paddingBottom: 0}} >
                <ListItem key="mw-security" disablePadding 
                    sx={{display: Array.isArray(menuACL) && SECURITY_INDEX < menuACL.length && menuACL[SECURITY_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton>
                        <ListItemIcon sx={{ fontSize: 18, paddingRight: 0, minWidth: '40px' }}>
                            <SecurityIcon />
                        </ListItemIcon>
                        <ListItemText primary="Security" slotsProps={{
                            primary: {
                                fontSize: 18,
                                fontWeight: theme.typography.fontWeightBold,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                <ListItem key="mw-security-mobile-users" disablePadding 
                    sx={{display: Array.isArray(menuACL) && MOBILE_USERS_INDEX < menuACL.length && menuACL[MOBILE_USERS_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleMobileUsersAction} selected={selectedIndex === MOBILE_USERS_INDEX}
                        disabled={Array.isArray(menuACL) && MOBILE_USERS_INDEX < menuACL.length && menuACL[MOBILE_USERS_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <ContactsIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Mobility Users" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                <ListItem key="mw-security-access" disablePadding 
                    sx={{display: Array.isArray(menuACL) && ACL_INDEX < menuACL.length && menuACL[ACL_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleAccessAction} selected={selectedIndex === ACL_INDEX}
                        disabled={Array.isArray(menuACL) && ACL_INDEX < menuACL.length && menuACL[ACL_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <AdminPanelSettingsIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Access Controls" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
            <List sx={{paddingTop: 0}}>
                <ListItem key="mw-roles" disablePadding 
                    sx={{display: Array.isArray(menuACL) && ROLES_INDEX < menuACL.length && menuACL[ROLES_INDEX].hide ? "none" : "block"}} >
                    <ListItemButton onClick={handleRolesAction} selected={selectedIndex === ROLES_INDEX}
                        disabled={Array.isArray(menuACL) && ROLES_INDEX < menuACL.length && menuACL[ROLES_INDEX].disabled} >
                        <ListItemIcon sx={{ paddingRight: 0,  paddingLeft: '40px', minWidth: '70px'}}>
                            <GroupsIcon fontSize="inherit"/>
                        </ListItemIcon>
                        <ListItemText primary="Roles" slotsProps={{
                            primary: {
                                fontSize: 16,
                                fontWeight: theme.typography.fontWeightMedium,
                                letterSpacing: 0,
                            }
                        }} />
                    </ListItemButton>
                </ListItem>
                
            </List>
        </Box>
    );
}


const ManagementModule = {
    // label
    name: 'management',
    label: 'Management',
    barLabel: 'Management',
    barShortLabel: 'Management',
    // icon
    icon: <ManageAccountsIcon fontSize="inherit" />,
    // menu
    drawerContent: <ManagementMenu />,
    // initial body page
    pageContent: null,
    cardContent: {page: <Box/>, name: 'Dummy', reuse: false, right: false},
    setCard: card => {},
    // send new body page on menu actions
    pageChange: (page) => {},
    drawerChange: (drawer) => {},
    drawerOpen: (open) => {},
    menuIconChange: (icon) => {},
    onMenuIconClick: (event) => {},
    drawerWidth: 260,

    hooks: {}, // { workflow: workflowInfo },
    route: {
        path: "management",
        element: <ManagementMenu />,
    },
    aclPaths: [ 
        {path: '/C/management', label: 'Management'}, 
        {path: '/C/management/workflow', label: 'Workflow'},
        // {path: '/C/management/workflow/templates', label: 'Templates'},
        {path: '/C/management/workflow/profiles', label: 'Templates & Profiling'},
        {path: '/C/management/workflow/forms', label: 'Forms'},
        // {path: '/C/management/workflow/definitions', label: 'Definitions'},
        {path: '/C/management/workflow/published', label: 'Published'},
        {path: '/C/management/workflow/runtime', label: 'Runtime'},
        {path: '/C/management/document', label: 'Documents'},
        {path: '/C/management/document/config', label: 'Configuration'},
        {path: '/C/management/database', label: 'Databases'},
        {path: '/C/management/database/eff', label: 'Effectivity'},
        {path: '/C/management/security', label: 'Security'}, 
        {path: '/C/management/security/musers', label: 'Mobile Users'},
        {path: '/C/management/security/acl', label: 'Access Controls'},
        {path: '/C/management/security/roles', label: 'Roles'}
    ],
}

export default ManagementModule;